// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"_24b9ba8d","outerContainer":"_21b5c266","secondaryToolbar":"_7030c502","doorHangerRight":"_6660c20e","toolbarContainer":"be9b3641","toolbarViewerMiddle":"_5985debd","progressBar":"_63f90470","back-to-application":"_3372632d","root":"bd70121e","upcoming-surveys":"_6f0116cc","title":"_1c2279ee","subtitle":"d9238b5a","buttons-wrapper":"e57674a8","surveys-list-button":"_3f0c3e89","surveys-list-button--active":"_107bac99","surveys-list-button--disabled":"_545aeb94","empty-state":"_74e7fd99","empty-state__text":"_21d6ff20","positionRelative":"_10c0a87c"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Surveys/index.styl
// module id = 565
// module chunks = 39